import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { Toast } from '../toast.model';
import { ToastService } from '../toast.service';
import { ToastItemComponent } from '../toast-item/toast-item.component';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule, ToastItemComponent],
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.css'],
})
export class ToastContainerComponent {
  toasts$: Observable<Toast[]>;

  constructor(public toast: ToastService) {
    this.toasts$ = toast.toasts$;
  }

  trackById(_: number, t: Toast) {
    return t.id;
  }
}
